import { styled } from "@mui/material";
import { Switch, Chip, TextField, Dialog, Select, Box } from "@mui/material";

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    width: "800px",
    padding: "24px",
    borderRadius: "8px",
    maxWidth: "90vw",
    minHeight: "80vh",
    minWidth: "50vw",
  },
}));

export const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 72,
  height: 41,
  padding: 8,
  display: "flex",
  alignItems: "center",
  "& .MuiSwitch-track": {
    borderRadius: 15,
    backgroundColor: "#b0bec5",
    position: "absolute",
    top: "50%",
    left: 0,
    right: 0,
    height: 20,
    transform: "translateY(-50%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&::before, &::after": {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      fontSize: "12px",
      fontWeight: "bold",
    },
    "&::before": {
      content: '"Full"',
      left: 26,
      color: theme.palette.text.secondary,
      display: "block",
    },
    "&::after": {
      content: '"Focus"',
      right: 26,
      color: theme.palette.text.secondary,
      display: "none",
    },
  },
  "& .MuiSwitch-thumb": {
    width: 18,
    height: 18,
    margin: 2,
    backgroundColor: "#fff",
  },
  "& .MuiSwitch-switchBase": {
    top: "50%",
    transform: "translateY(-50%)",
    padding: 2,
    "&.Mui-checked": {
      transform: "translate(49px, -50%)",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.primary.main,
        "&::before, &::after": {
          color: "#fff",
        },
      },
      "& + .MuiSwitch-track::before": {
        display: "none",
      },
      "& + .MuiSwitch-track::after": {
        display: "block",
      },
    },
  },
}));

export const StyledChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.action.hover,
  borderRadius: "4px",
  height: "24px",
  "& .MuiChip-label": {
    padding: "0 8px",
    fontSize: "12px",
    color: theme.palette.text.secondary,
  },
  margin: "2px",
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: theme.palette.background.paper,
    "& fieldset": {
      borderColor: theme.palette.divider,
    },
  },
  marginBottom: "16px",
}));

export const StyledSelect = styled(Select)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  marginBottom: "20px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.divider,
  },
}));

export const ScreenshotContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  minHeight: "200px",
}));
